export enum Currency {
  NOK = 'NOK',
  PLN = 'PLN',
  EUR = 'EUR',
  USD = 'USD'
}
